import { useMemo } from 'react';
import { useSuperAdmin } from '../util/permissions';

export default (t) => {
  const superAdmin = useSuperAdmin();
  return useMemo(() => ({
  'command.sender': {
    name: t('deviceCommandSender'),
    type: 'string',
  },
  'web.reportColor': {
    name: t('attributeWebReportColor'),
    type: 'string',
    subtype: 'color',
  },
  devicePassword: {
    name: t('attributeDevicePassword'),
    type: 'string',
  },
  deviceImage: {
    name: t('attributeDeviceImage'),
    type: 'string',
  },
  'processing.copyAttributes': {
    name: t('attributeProcessingCopyAttributes'),
    type: 'string',
  },
  'decoder.timezone': {
    name: t('sharedTimezone'),
    type: 'string',
  },
  'forward.url': {
    name: t('attributeForwardUrl'),
    type: 'string',
  },
  // MOD //
  lockOnEnter: {
    name: t('lockOnEnter'),
    type: 'boolean',
  },
  lockOnExit: {
    name: t('lockOnExit'),
    type: 'boolean',
  },
  hasAnchor: {
    name: t('hasAnchor'),
    type: 'boolean',
  },
  // Camera attributes
  hasCamera: {
    name: t('attributeHasCamera'),
    type: 'boolean',
  },
  videoBackend: {
    name: t('attributeVideoBackend'),
    type: 'string',
  },
  cameraChannels: {
    name: t('attributeCameraChannels'),
    type: 'number',
  },
  defaultCameraChannel: {
    name: t('attributeDefaultCameraChannel'),
    type: 'number',
  },
  ...(superAdmin ? {
    'ee05cam.cameraEnabled': {
      name: 'Camera Habilitada (EE05Cam)',
      type: 'boolean',
    },
    'feature.ibutton.enabled': {
      name: 'Feature: iButton / Driver ID',
      type: 'boolean',
    },
    'feature.tags.enabled': {
      name: 'Feature: BLE Tags',
      type: 'boolean',
    },
  } : {}),
}), [t, superAdmin]);
};
